/** Hinterlegtes Dokument einer Online-Anmeldung. Link oder Text, je Schule. */
export const LEGAL_DOCUMENTS = {
  agb: {
    label: 'AGB',
    title: 'Allgemeine Geschäftsbedingungen (AGB)',
    textKey: 'agb_text',
    urlKey: 'agb_url',
  },
  datenschutz: {
    label: 'Datenschutzerklärung',
    title: 'Datenschutzerklärung',
    textKey: 'datenschutz_text',
    urlKey: 'datenschutz_url',
  },
  widerruf: {
    label: 'Widerrufsbelehrung',
    title: 'Widerrufsbelehrung',
    textKey: 'widerruf_text',
    urlKey: 'widerruf_url',
  },
};

export function legalDocumentHref(config, kind) {
  const spec = LEGAL_DOCUMENTS[kind];
  if (!spec || !config) return '';
  const url = String(config[spec.urlKey] || '').trim();
  if (isHttpUrl(url)) return url;
  const text = String(config[spec.textKey] || '').trim();
  const slug = String(config.tenant_slug || '').trim();
  if (text && slug) return `/anmeldung/${encodeURIComponent(slug)}/rechtstext/${kind}`;
  return '';
}

function isHttpUrl(value) {
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (_e) {
    return false;
  }
}
